module.exports = __webpack_public_path__ + "img/liqtrans.a762f7c0.png";